module.exports = __webpack_public_path__ + "static/media/bobcat.49600f04.jpg";